export const messages = {
  "error_notice.reference": "Reference: {request_id}",
  "error_notice.retry": "Try again",
  "error_boundary.title": "Something went wrong",
  "error_boundary.body": "This page couldn't load. Reload to try again.",
  "error_boundary.reload": "Reload",
};

export function format(key, values = {}) {
  return messages[key].replace(/\{(\w+)\}/g, (_, name) => values[name] ?? "");
}
